import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Card } from '@material-ui/core';
import moment from 'moment';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  body: {
    background: theme.palette.bgElements,
    minHeight: '50vh',
    padding: '10px 10px'
  },
  itemWrap: {
    fontWeight: 500
  },
  itemLabel: {
    fontWeight: 200
  }
}));

function RmsIncident(props) {
  const { data, themeMode } = props;
  const classes = useStyles();

  console.log(data);

  if (data !== null) {
    return (
      <div className="table-responsive">
        <table
          className={clsx(
            'table',
            themeMode === 'night' && 'table-pts-night',
            themeMode === 'day' && 'table-pts-day',
            'text-nowrap',
            'mb-0'
          )}>
          <thead>
            <tr>
              <th className="bg-white text-center">Incident ID</th>
              <th className="bg-white">Date</th>
              <th className="bg-white text-center">Relationship</th>
              <th className="bg-white text-center">Category</th>
              <th className="bg-white text-center">Method</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, idx) => {
              return (
                <tr key={idx}>
                  <td>{row.IncidentID}</td>
                  <td>
                    {row.OccurredDate
                      ? moment(row.OccurredDate).format('MM/DD/YYYY, h:mm a')
                      : ''}
                  </td>
                  <td>{row.PersonRelationship}</td>
                  <td>{row.IncidentCategory}</td>
                  <td>{row.CADMethod}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  } else {
    return (
      <Card className="card-box bg-neutral-warning border-1 card-border-top border-warning text-center p-3">
        <h4 style={{ marginBottom: 0, color: 'black' }}>
          Sorry, no RMS Incidents found.
        </h4>
      </Card>
    );
  }
}

export default RmsIncident;
